module.exports = __webpack_public_path__ + "static/media/RedCalendar.9bdd3fa5.svg";